<template>
  <autocomplete-single
      name="Внешний шаблон"
      :items="items"
      :select.sync="localSelect"
      :loading="loadState.isLoading"
      clearable
      @load="load"
  >
    <template v-slot:itemIcon="{item}">
      <v-avatar
          v-if="providerById(item.provider)"
          :color="providerById(item.provider).iconBgColor"
          size="18"
          class="mr-1"
      >
        <v-icon color="white" size="12">{{ providerById(item.provider).icon }}</v-icon>
      </v-avatar>
    </template>
    <template v-slot:itemInfo="{item}">
      <v-sheet color="transparent" class="text-wrap caption" max-width="400"
               v-html="$tools.nl2br(item.text || '')"></v-sheet>
    </template>
    <template v-slot:selectedInfo="{item}">
      <v-avatar
          v-if="providerById(item.provider)"
          :color="providerById(item.provider).iconBgColor"
          size="14"
          class="mr-1"
          style="margin-top:-2px"
      >
        <v-icon color="white" size="10">{{ providerById(item.provider).icon }}</v-icon>
      </v-avatar>
      <span class="caption">{{ providerLabel(item.provider) }}</span>
      <span v-if="!$tools.isEmpty(item.sid)"> · {{ item.sid }}</span>
    </template>
  </autocomplete-single>
</template>

<script>
import State from "@/plugins/state";
import axios from "axios";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import {Entity_DialogMessageTemplateExternal,} from "../../../EntityStoreCacheService";

export default {
  components: {AutocompleteSingle},
  props: [
    'select',
  ],
  data: () => ({
    loadState: new State(),
    items: [],
    localSelect: null,
    providers: [],
  }),
  computed: {
    providersMap() {
      const map = {};
      this.providers.forEach(p => {
        map[p.id] = p;
      });
      return map;
    },
  },
  watch: {
    select(v) {
      const selectId = v && v.id != null ? v.id : null;
      const localId = this.localSelect && this.localSelect.id != null ? this.localSelect.id : null;
      if (selectId === localId)
        return;
      this.applySelect();
    },
    localSelect(v) {
      const selectId = this.select && this.select.id != null ? this.select.id : null;
      const localId = v && v.id != null ? v.id : null;
      if (selectId === localId)
        return;
      this.$emit('update:select', v);
    }
  },
  mounted() {
    this.applySelect();
    this.loadProviders();
  },
  methods: {
    applySelect() {
      if (this.select && this.select.id != null) {
        const item = {
          ...this.select,
          name: this.select.name || [this.providerLabel(this.select.provider), this.select.sid, this.select.text]
              .filter(Boolean).join(' '),
        };
        this.localSelect = item;
        if (!this.items.find(i => i.id === item.id))
          this.items = [item, ...this.items];
      } else {
        this.localSelect = null;
      }
    },
    providerById(id) {
      return this.providersMap[id] || null;
    },
    providerLabel(provider) {
      return this.providersMap[provider]?.name || provider;
    },
    loadProviders() {
      return axios.get('/napi/dialog/provider/').then(r => {
        this.providers = r.data;
        if (this.localSelect && this.localSelect.id != null && !this.localSelect.name) {
          this.$set(
              this.localSelect,
              'name',
              [this.providerLabel(this.localSelect.provider), this.localSelect.sid, this.localSelect.text]
                  .filter(Boolean).join(' ')
          );
        }
      });
    },
    reload() {
      this.items = [];
      this.load();
    },
    async load() {
      if (this.providers.length === 0)
        await this.loadProviders();
      new Entity_DialogMessageTemplateExternal()
          .selects(Entity_DialogMessageTemplateExternal.id)
          .selects(Entity_DialogMessageTemplateExternal.provider)
          .selects(Entity_DialogMessageTemplateExternal.sid)
          .selects(Entity_DialogMessageTemplateExternal.text)
          .order(Entity_DialogMessageTemplateExternal.id, false)
          .page(null)
          .addStateCallback((v) => this.loadState.setRequestBuilderState(v))
          .request((v) => {
            v.items.forEach(item => {
              item.name = [this.providerLabel(item.provider), item.sid, item.text].filter(Boolean).join(' ');
            });
            if (this.localSelect && this.localSelect.id != null && !v.items.find(i => i.id === this.localSelect.id))
              v.items = [this.localSelect, ...v.items];
            this.items = v.items;
          }, (e) => {
            console.error(e.response.data.message);
          })
    }
  }
}
</script>
